import "../Css/Intro.css";
import Header from "./Header";
import About from "./About";
import IntroBody from "./IntroBody";
export default function Intro() {
  return (
    <div className="Intro-container">
      <div className="Intro-content">
        <Header />
        <IntroBody />
        <About />
      </div>
    </div>
  );
}
